<template>
  <div id="app">
    <aboutBTC id="aboutus1"/>
    <terms id="statement1"/>
    <privacy-policy id="privacypolicy1"/>
    <contact-us id="contact1"/>
    <router-view/>
  </div>
</template>

<script>
import $ from 'jquery'
import { mapGetters } from 'vuex'
import { wxShareInit } from '@/utils/wxshare'
import { getFirstWarn, setFirstWarn, isWeChat } from '@/utils'
import { getLocalStore, getStore, setStore } from '@/utils/common'
import AboutBTC from '@/views/layout_en/components/Footer/components/AboutBTC'
import Terms from '@/views/layout_en/components/Footer/components/Terms'
import PrivacyPolicy from '@/views/layout_en/components/Footer/components/PrivacyPolicy'
import ContactUs from '@/views/layout_en/components/Footer/components/ContactUs'

export default {
  name: 'App',
  components: {
    AboutBTC,
    Terms,
    PrivacyPolicy,
    ContactUs
  },
  data() {
    return {
      isLogin: getStore().isAutoLogin
    }
  },
  computed: {
    ...mapGetters([
      'name',
      'userow'
    ])
  },
  watch: {
    $route(to, from) {
      const section = to.query.popsection
      if (section === 'aboutus') {
        $('#aboutus1').modal('show')
      }
      if (section === 'privacy') {
        $('#privacypolicy1').modal('show')
      }
      if (section === 'statement') {
        $('#statement1').modal('show')
      }
      if (section === 'contact') {
        $('#contact1').modal('show')
      }
    },
    // 域名切换
    // $route(to, from) {
    //   if (to.path.includes('BTCInfo') && window.location.href.includes('porktest.com')) {
    //     if (to.path.toLowerCase().includes('english')) {
    //       window.location.href = 'http://beeftest.com:8088/english/BTCInfo'
    //     } else {
    //       window.location.href = 'http://beeftest.com:8088/BTCInfo'
    //     }
    //   }
    //   if (to.path.includes('PTCInfo') && window.location.href.includes('beeftest.com')) {
    //     if (to.path.toLowerCase().includes('english')) {
    //       window.location.href = 'http://porktest.com:8088/english/PTCInfo'
    //     } else {
    //       window.location.href = 'http://porktest.com:8088/PTCInfo'
    //     }
    //   }
    // },
    '$route.path'(val) {
      val = val.toLowerCase()
      if (!val.includes('article')) {
        document.title = 'Beef to China'
      }
    }
  },
  created() {
    window.addEventListener('load', () => {
      if (this.$store.getters.name) {
        this.$store.dispatch('GetUserProfile', this.$store.getters.name)
      }
    })
    if (!this.isLogin) {
      this.autoLogin()
    }
    // if (!getLocalStore().token) {
    //   delLocalStore()
    // }
  },
  updated() {
    if (isWeChat()) {
      wxShareInit(this)
    }
  },
  methods: {
    autoLogin() {
      setStore({ isAutoLogin: true })
      const token = getLocalStore().token
      if (token) {
        this.$store.dispatch('GetUserProfileByToken', token).then(() => {
          // 续费提醒
          if ((!this.isEN && this.userow.ChargeState === 3) || (this.isEN && this.userow.ChargeStataEn === 3)) {
            const expiretime = this.isEN ? this.userow.ChargeEnExpireDate : this.userow.ChargeExpireDate
            const isFirstWarn = getFirstWarn(this.name, expiretime)
            if (isFirstWarn) {
              setFirstWarn(this.name, expiretime)
              // 弹出提示
              $('#renewalModal').modal({ show: true })
            }
            // 过期提醒
            if (new Date(expiretime) < new Date()) {
              $('#renewalModal').modal({ show: true })
            }
          }
        })
      }
      this.$store.dispatch('UpdateUserActivityByToken', token)
    }
  }
}
</script>
<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
.header {
  position: sticky!important;
  position: -webkit-sticky!important;
  top: 0px!important;
}
a { text-decoration: none!important }
.open>.dropdown-menu { display: none; }
</style>



// WEBPACK FOOTER //
// src/App.vue